var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    {
      attrs: {
        width: "24",
        height: "16",
        viewBox: "0 0 24 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }
    },
    [
      _c("path", {
        attrs: {
          d:
            "M19.935 15.4762H1.815C1.57862 15.4782 1.34416 15.4329 1.12502 15.3428C0.905875 15.2528 0.706336 15.1198 0.537796 14.9514C0.369256 14.783 0.235016 14.5825 0.14274 14.3614C0.050465 14.1404 0.00196164 13.903 0 13.6628L0 2.81331C0.00196164 2.57317 0.050465 2.33578 0.14274 2.11469C0.235016 1.8936 0.369256 1.69314 0.537796 1.52475C0.706336 1.35637 0.905875 1.22336 1.12502 1.13332C1.34416 1.04327 1.57862 0.997963 1.815 0.999972H19.935C20.1714 0.997963 20.4058 1.04327 20.625 1.13332C20.8441 1.22336 21.0437 1.35637 21.2122 1.52475C21.3807 1.69314 21.515 1.8936 21.6073 2.11469C21.6995 2.33578 21.748 2.57317 21.75 2.81331V13.6704C21.7441 14.1541 21.5497 14.6157 21.2096 14.9541C20.8694 15.2925 20.4111 15.4802 19.935 15.4762ZM7.5 5.44188C7.5 5.0914 7.2375 4.8095 6.915 4.8095H2.835C2.5125 4.8095 2.25 5.0914 2.25 5.44188V7.98664C2.25 8.33712 2.5125 8.61902 2.835 8.61902H6.915C7.2375 8.61902 7.5 8.33712 7.5 7.98664V5.44188Z",
          fill: "#E1E3E7"
        }
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          opacity: "0.3",
          d:
            "M18.75 12.4286H16.5C16.0125 12.4286 15.75 12.2 15.75 11.6667C15.75 11.1333 16.0125 10.9048 16.5 10.9048H18.75C19.2375 10.9048 19.5 11.1333 19.5 11.6667C19.5 12.2 19.2375 12.4286 18.75 12.4286ZM14.25 12.4286H12C11.5125 12.4286 11.25 12.2 11.25 11.6667C11.25 11.1333 11.5125 10.9048 12 10.9048H14.25C14.7375 10.9048 15 11.1333 15 11.6667C15 12.2 14.7375 12.4286 14.25 12.4286ZM9.75 12.4286H7.5C7.0125 12.4286 6.75 12.2 6.75 11.6667C6.75 11.1333 7.0125 10.9048 7.5 10.9048H9.75C10.2375 10.9048 10.5 11.1333 10.5 11.6667C10.5 12.2 10.2375 12.4286 9.75 12.4286ZM5.25 12.4286H3C2.5125 12.4286 2.25 12.2 2.25 11.6667C2.25 11.1333 2.5125 10.9048 3 10.9048H5.25C5.7375 10.9048 6 11.1333 6 11.6667C6 12.2 5.7375 12.4286 5.25 12.4286Z",
          fill: "black"
        }
      })
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }